// 아이템 등급(rarity) — 색과 이름의 **단일 지점**
//
// 왜 생겼나: 같은 표가 화면마다 따로 살아 있었다(인벤·도감·RpgFrame·NpcModal·상세·퀘스트·
// 상자·판매대·드롭·채집·토스트 — 11벌). 그래서 세 가지가 동시에 어긋나 있었다:
//
//   ① **없는 등급은 회색으로 떨어졌다** — RpgFrame·NpcModal·판매대·채집에 `mythic` 이 없어
//      심연 장비가 슬롯 테두리에선 「일반」과 같은 색이었다. 폴백이라 에러도 안 났다.
//   ② **같은 등급이 다른 이름으로 불렸다** — epic 이 인벤에선 '에픽', 도감·상세에선 '영웅'.
//   ③ **같은 등급이 다른 색이었다** — uncommon 만 네 가지 초록(#86efac·#7fc98a·#9fe6b8·#7ddc9a).
//
// 색의 기준은 **월드가 이미 말하고 있는 것**이다 — 오라(`enhanceStyle.RARITY_TIER_COLOR`)와
// 드롭 광선이 쓰는 값을 정본으로 삼았다. UI 가 보라라고 쓰는데 발밑 링이 주황이면 둘 다 거짓말이 된다.
//
// ⚠ 여기 없는 것: **모양**(글로우 반경·광선 개수·빔 높이·흔들림 시간). 그건 화면마다 다른 게
//   맞다 — 3D 빔은 미터로 튜닝돼 있고 CSS 글로우는 픽셀이다. 소비처는 **색과 이름만** 여기서
//   가져가고 세기는 자기 축으로 만든다. 색을 여기 두는 이유는 그게 「무엇인가」의 진술이라서다.

/** 낮은 것부터 — 정렬·비교의 기준 순서 */
export const RARITY_ORDER = ['common', 'uncommon', 'rare', 'epic', 'legendary', 'mythic'];

/** 글자·아이콘·강조에 쓰는 등급색 */
export const RARITY_COLOR = {
  common:    '#cbd5e1',
  uncommon:  '#7fc98a',
  rare:      '#60a5fa',
  epic:      '#c084fc',
  legendary: '#fbbf24',
  mythic:    '#a78bfa',
};

/** 테두리용 — `common` 만 다르다. 글자는 속삭여도 되지만 **테두리는 칸마다 반복**돼서,
 *  흔한 등급까지 밝게 두면 인벤 한 판이 통째로 빛나 등급 신호가 죽는다. */
export const RARITY_FRAME = { ...RARITY_COLOR, common: '#5a6b7a' };

/** 한글 표시명. `mythic` 은 '심연'이 아니라 **'신화'** 다 — 심연은 지금 유일한 mythic
 *  **세트 이름**이고(item.set_label), 등급 이름으로 같이 쓰면 「등급」과 「세트」 두 축이
 *  한 단어가 된다. 다음 mythic 세트를 시드하는 날 조용히 틀리는 종류의 이름이다. */
export const RARITY_LABEL = {
  common: '일반', uncommon: '고급', rare: '희귀',
  epic: '영웅', legendary: '전설', mythic: '신화',
};

/** 등급이 얼마나 「크게 말하나」 0~1 — 세기를 자기 단위로 만들 때의 공통 계수 */
export const RARITY_EMPHASIS = {
  common: 0, uncommon: 0.2, rare: 0.5, epic: 0.7, legendary: 0.9, mythic: 1,
};

const norm = (r) => String(r || '').toLowerCase();

export const rarityColor = (r, fallback = RARITY_COLOR.common) => RARITY_COLOR[norm(r)] || fallback;
export const rarityLabel = (r) => RARITY_LABEL[norm(r)] || r;
export const rarityEmphasis = (r) => RARITY_EMPHASIS[norm(r)] ?? 0;

/** `#rrggbb` → `rgba(r,g,b,a)`. 등급색을 테두리·배경으로 옅게 깔 때 쓴다. */
export const withAlpha = (hex, a = 1) => {
  const h = String(hex || '').replace('#', '');
  if (h.length !== 6) return hex;
  const n = parseInt(h, 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
};
